import styled from "@emotion/styled";
import { colors } from "styles/colors";

export const RadioButtonWrap = styled.label`
  display: block;
  margin: 4px 0 0;
  + * {
    margin-top: 15px;
  }
  @media (min-width: 320px) {
    display: inline-block !important;
    vertical-align: middle;
    margin: 4px 0 0 10px;
    &:first-of-type {
      margin-left: 0;
    }
  }
  @media (min-width: 360px) {
    margin: 4px 0 0 30px;
  }
  input {
    display: none;
  }

  .radio {
    cursor: pointer;
    width: 18px;
    height: 18px;
    background-color: ${colors.WHITE};
    border: 1px solid ${colors.GREY_SEMIDARK};
    position: relative;
    border-radius: 35px;
    display: inline-block;
  }

  .radio:before {
    content: "";
    width: 8px;
    height: 8px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 10px;
    opacity: 0;
    background-color: transparent;
    transition: 0.2s;
  }
  ${(props) =>
    props.isRed
      ? `
  input:checked + .radio:before {
    opacity: 1;
    background-color:${colors.RED};
  }
  `
      : `
  input:checked + .radio:before {
  opacity: 1;
  background-color: ${colors.RED};
}`};
  span {
    vertical-align: middle;
    color: ${colors.GREY_SEMIDARK};
    font-size: 16px;
  }
  span + span {
    margin-left: 8px;
    @media (min-width: 360px) {
      margin-left: 12px;
    }
  }
`;

export const WrapMessage = styled.div`
  color: ${colors.RED};
  margin-top: 5px;
  font-size: 12px;
`;
